// extracted by mini-css-extract-plugin
export default {"container":"xR-z","title":"yR-z","link":"zR-z"};